// Complete city list: All 38 Indonesian provinces + All world countries with major cities

export const CITY_OPTIONS = [
  // ==========================================
  // INDONESIA - ALL 38 PROVINCES
  // ==========================================
  // Aceh
  'Indonesia - Aceh - Banda Aceh',
  'Indonesia - Aceh - Lhokseumawe',
  'Indonesia - Aceh - Langsa',
  'Indonesia - Aceh - Sabang',
  'Indonesia - Aceh - Meulaboh',
  // Sumatera Utara
  'Indonesia - Sumatera Utara - Medan',
  'Indonesia - Sumatera Utara - Pematang Siantar',
  'Indonesia - Sumatera Utara - Binjai',
  'Indonesia - Sumatera Utara - Padang Sidempuan',
  'Indonesia - Sumatera Utara - Tanjung Balai',
  'Indonesia - Sumatera Utara - Sibolga',
  'Indonesia - Sumatera Utara - Tebing Tinggi',
  'Indonesia - Sumatera Utara - Gunungsitoli',
  // Sumatera Barat
  'Indonesia - Sumatera Barat - Padang',
  'Indonesia - Sumatera Barat - Bukittinggi',
  'Indonesia - Sumatera Barat - Payakumbuh',
  'Indonesia - Sumatera Barat - Solok',
  'Indonesia - Sumatera Barat - Sawahlunto',
  'Indonesia - Sumatera Barat - Pariaman',
  // Riau
  'Indonesia - Riau - Pekanbaru',
  'Indonesia - Riau - Dumai',
  // Kepulauan Riau
  'Indonesia - Kepulauan Riau - Batam',
  'Indonesia - Kepulauan Riau - Tanjung Pinang',
  // Jambi
  'Indonesia - Jambi - Jambi',
  'Indonesia - Jambi - Sungai Penuh',
  // Sumatera Selatan
  'Indonesia - Sumatera Selatan - Palembang',
  'Indonesia - Sumatera Selatan - Prabumulih',
  'Indonesia - Sumatera Selatan - Pagar Alam',
  'Indonesia - Sumatera Selatan - Lubuklinggau',
  // Bengkulu
  'Indonesia - Bengkulu - Bengkulu',
  // Lampung
  'Indonesia - Lampung - Bandar Lampung',
  'Indonesia - Lampung - Metro',
  // Bangka Belitung
  'Indonesia - Bangka Belitung - Pangkal Pinang',
  // DKI Jakarta
  'Indonesia - DKI Jakarta - Jakarta Pusat',
  'Indonesia - DKI Jakarta - Jakarta Utara',
  'Indonesia - DKI Jakarta - Jakarta Barat',
  'Indonesia - DKI Jakarta - Jakarta Selatan',
  'Indonesia - DKI Jakarta - Jakarta Timur',
  'Indonesia - DKI Jakarta - Kepulauan Seribu',
  // Banten
  'Indonesia - Banten - Tangerang',
  'Indonesia - Banten - Tangerang Selatan (BSD)',
  'Indonesia - Banten - Serang',
  'Indonesia - Banten - Cilegon',
  'Indonesia - Banten - Pantai Indah Kapuk (PIK)',
  // Jawa Barat
  'Indonesia - Jawa Barat - Bandung',
  'Indonesia - Jawa Barat - Bekasi',
  'Indonesia - Jawa Barat - Depok',
  'Indonesia - Jawa Barat - Bogor',
  'Indonesia - Jawa Barat - Cirebon',
  'Indonesia - Jawa Barat - Sukabumi',
  'Indonesia - Jawa Barat - Tasikmalaya',
  'Indonesia - Jawa Barat - Cimahi',
  'Indonesia - Jawa Barat - Karawang',
  'Indonesia - Jawa Barat - Cikarang',
  'Indonesia - Jawa Barat - Banjar',
  // Jawa Tengah
  'Indonesia - Jawa Tengah - Semarang',
  'Indonesia - Jawa Tengah - Solo (Surakarta)',
  'Indonesia - Jawa Tengah - Purwokerto',
  'Indonesia - Jawa Tengah - Tegal',
  'Indonesia - Jawa Tengah - Pekalongan',
  'Indonesia - Jawa Tengah - Magelang',
  'Indonesia - Jawa Tengah - Salatiga',
  'Indonesia - Jawa Tengah - Kudus',
  // DI Yogyakarta
  'Indonesia - DI Yogyakarta - Yogyakarta',
  'Indonesia - DI Yogyakarta - Sleman',
  'Indonesia - DI Yogyakarta - Bantul',
  // Jawa Timur
  'Indonesia - Jawa Timur - Surabaya',
  'Indonesia - Jawa Timur - Malang',
  'Indonesia - Jawa Timur - Kediri',
  'Indonesia - Jawa Timur - Jember',
  'Indonesia - Jawa Timur - Madiun',
  'Indonesia - Jawa Timur - Mojokerto',
  'Indonesia - Jawa Timur - Pasuruan',
  'Indonesia - Jawa Timur - Probolinggo',
  'Indonesia - Jawa Timur - Blitar',
  'Indonesia - Jawa Timur - Batu',
  'Indonesia - Jawa Timur - Sidoarjo',
  'Indonesia - Jawa Timur - Gresik',
  // Bali
  'Indonesia - Bali - Denpasar',
  'Indonesia - Bali - Badung (Kuta)',
  'Indonesia - Bali - Gianyar (Ubud)',
  'Indonesia - Bali - Tabanan',
  'Indonesia - Bali - Singaraja',
  'Indonesia - Bali - Karangasem',
  // Nusa Tenggara Barat
  'Indonesia - NTB - Mataram (Lombok)',
  'Indonesia - NTB - Bima',
  'Indonesia - NTB - Sumbawa Besar',
  // Nusa Tenggara Timur
  'Indonesia - NTT - Kupang',
  'Indonesia - NTT - Ende',
  'Indonesia - NTT - Maumere',
  'Indonesia - NTT - Labuan Bajo',
  // Kalimantan Barat
  'Indonesia - Kalimantan Barat - Pontianak',
  'Indonesia - Kalimantan Barat - Singkawang',
  // Kalimantan Tengah
  'Indonesia - Kalimantan Tengah - Palangka Raya',
  // Kalimantan Selatan
  'Indonesia - Kalimantan Selatan - Banjarmasin',
  'Indonesia - Kalimantan Selatan - Banjarbaru',
  // Kalimantan Timur
  'Indonesia - Kalimantan Timur - Samarinda',
  'Indonesia - Kalimantan Timur - Balikpapan',
  'Indonesia - Kalimantan Timur - Bontang',
  // Kalimantan Utara
  'Indonesia - Kalimantan Utara - Tarakan',
  'Indonesia - Kalimantan Utara - Tanjung Selor',
  // Sulawesi Utara
  'Indonesia - Sulawesi Utara - Manado',
  'Indonesia - Sulawesi Utara - Bitung',
  'Indonesia - Sulawesi Utara - Tomohon',
  'Indonesia - Sulawesi Utara - Kotamobagu',
  // Gorontalo
  'Indonesia - Gorontalo - Gorontalo',
  // Sulawesi Tengah
  'Indonesia - Sulawesi Tengah - Palu',
  'Indonesia - Sulawesi Tengah - Morowali (IMIP)',
  // Sulawesi Selatan
  'Indonesia - Sulawesi Selatan - Makassar',
  'Indonesia - Sulawesi Selatan - Palopo',
  'Indonesia - Sulawesi Selatan - Parepare',
  // Sulawesi Tenggara
  'Indonesia - Sulawesi Tenggara - Kendari',
  'Indonesia - Sulawesi Tenggara - Baubau',
  // Sulawesi Barat
  'Indonesia - Sulawesi Barat - Mamuju',
  // Maluku
  'Indonesia - Maluku - Ambon',
  'Indonesia - Maluku - Tual',
  // Maluku Utara
  'Indonesia - Maluku Utara - Ternate',
  'Indonesia - Maluku Utara - Tidore',
  'Indonesia - Maluku Utara - Sofifi',
  // Papua
  'Indonesia - Papua - Jayapura',
  'Indonesia - Papua - Merauke',
  // Papua Barat
  'Indonesia - Papua Barat - Manokwari',
  'Indonesia - Papua Barat - Sorong',
  // Papua Selatan
  'Indonesia - Papua Selatan - Merauke',
  // Papua Tengah
  'Indonesia - Papua Tengah - Nabire',
  // Papua Pegunungan
  'Indonesia - Papua Pegunungan - Wamena',
  // Papua Barat Daya
  'Indonesia - Papua Barat Daya - Sorong Selatan',

  // ==========================================
  // ALL COUNTRIES (with major cities)
  // ==========================================
  // Asia
  'Afghanistan - Kabul',
  'Armenia - Yerevan',
  'Azerbaijan - Baku',
  'Bahrain - Manama',
  'Bangladesh - Dhaka',
  'Bangladesh - Chittagong',
  'Bhutan - Thimphu',
  'Brunei - Bandar Seri Begawan',
  'Cambodia - Phnom Penh',
  'Cambodia - Siem Reap',
  'China - Beijing',
  'China - Shanghai',
  'China - Guangzhou',
  'China - Shenzhen',
  'China - Chengdu',
  'China - Hangzhou',
  'China - Wuhan',
  'China - Nanjing',
  'China - Xiamen',
  'China - Suzhou',
  'China - Tianjin',
  'China - Chongqing',
  'Cyprus - Nicosia',
  'Georgia - Tbilisi',
  'Hong Kong - Hong Kong',
  'India - Mumbai',
  'India - Delhi',
  'India - Bangalore',
  'India - Chennai',
  'India - Kolkata',
  'India - Hyderabad',
  'India - Pune',
  'India - Ahmedabad',
  'Iraq - Baghdad',
  'Iran - Tehran',
  'Israel - Tel Aviv',
  'Israel - Jerusalem',
  'Japan - Tokyo',
  'Japan - Osaka',
  'Japan - Nagoya',
  'Japan - Fukuoka',
  'Japan - Sapporo',
  'Japan - Yokohama',
  'Japan - Kyoto',
  'Jordan - Amman',
  'Kazakhstan - Almaty',
  'Kazakhstan - Astana',
  'Kuwait - Kuwait City',
  'Kyrgyzstan - Bishkek',
  'Laos - Vientiane',
  'Lebanon - Beirut',
  'Macau - Macau',
  'Malaysia - Kuala Lumpur',
  'Malaysia - Penang',
  'Malaysia - Johor Bahru',
  'Malaysia - Kota Kinabalu',
  'Malaysia - Kuching',
  'Maldives - Male',
  'Mongolia - Ulaanbaatar',
  'Myanmar - Yangon',
  'Nepal - Kathmandu',
  'North Korea - Pyongyang',
  'Oman - Muscat',
  'Pakistan - Karachi',
  'Pakistan - Lahore',
  'Pakistan - Islamabad',
  'Palestine - Ramallah',
  'Philippines - Manila',
  'Philippines - Cebu',
  'Philippines - Davao',
  'Qatar - Doha',
  'Saudi Arabia - Riyadh',
  'Saudi Arabia - Jeddah',
  'Saudi Arabia - Mecca',
  'Saudi Arabia - Medina',
  'Singapore - Singapore',
  'South Korea - Seoul',
  'South Korea - Busan',
  'South Korea - Incheon',
  'South Korea - Daegu',
  'South Korea - Daejeon',
  'South Korea - Gwangju',
  'South Korea - Jeju',
  'Sri Lanka - Colombo',
  'Syria - Damascus',
  'Taiwan - Taipei',
  'Taiwan - Kaohsiung',
  'Taiwan - Taichung',
  'Taiwan - Tainan',
  'Taiwan - Hsinchu',
  'Taiwan - Taoyuan',
  'Tajikistan - Dushanbe',
  'Thailand - Bangkok',
  'Thailand - Chiang Mai',
  'Thailand - Phuket',
  'Thailand - Pattaya',
  'Timor Leste - Dili',
  'Turkmenistan - Ashgabat',
  'UAE - Dubai',
  'UAE - Abu Dhabi',
  'UAE - Sharjah',
  'Uzbekistan - Tashkent',
  'Vietnam - Ho Chi Minh City',
  'Vietnam - Hanoi',
  'Vietnam - Da Nang',
  'Yemen - Sanaa',

  // Europe
  'Albania - Tirana',
  'Andorra - Andorra la Vella',
  'Austria - Vienna',
  'Austria - Salzburg',
  'Belarus - Minsk',
  'Belgium - Brussels',
  'Belgium - Antwerp',
  'Bosnia and Herzegovina - Sarajevo',
  'Bulgaria - Sofia',
  'Croatia - Zagreb',
  'Czech Republic - Prague',
  'Denmark - Copenhagen',
  'Estonia - Tallinn',
  'Finland - Helsinki',
  'France - Paris',
  'France - Lyon',
  'France - Marseille',
  'France - Nice',
  'Germany - Berlin',
  'Germany - Munich',
  'Germany - Hamburg',
  'Germany - Frankfurt',
  'Germany - Cologne',
  'Germany - Stuttgart',
  'Greece - Athens',
  'Greece - Thessaloniki',
  'Hungary - Budapest',
  'Iceland - Reykjavik',
  'Ireland - Dublin',
  'Italy - Rome',
  'Italy - Milan',
  'Italy - Florence',
  'Italy - Naples',
  'Italy - Venice',
  'Kosovo - Pristina',
  'Latvia - Riga',
  'Liechtenstein - Vaduz',
  'Lithuania - Vilnius',
  'Luxembourg - Luxembourg City',
  'Malta - Valletta',
  'Moldova - Chisinau',
  'Monaco - Monaco',
  'Montenegro - Podgorica',
  'Netherlands - Amsterdam',
  'Netherlands - Rotterdam',
  'Netherlands - The Hague',
  'North Macedonia - Skopje',
  'Norway - Oslo',
  'Norway - Bergen',
  'Poland - Warsaw',
  'Poland - Krakow',
  'Poland - Wroclaw',
  'Portugal - Lisbon',
  'Portugal - Porto',
  'Romania - Bucharest',
  'Russia - Moscow',
  'Russia - Saint Petersburg',
  'San Marino - San Marino',
  'Serbia - Belgrade',
  'Slovakia - Bratislava',
  'Slovenia - Ljubljana',
  'Spain - Madrid',
  'Spain - Barcelona',
  'Spain - Valencia',
  'Spain - Seville',
  'Sweden - Stockholm',
  'Sweden - Gothenburg',
  'Switzerland - Zurich',
  'Switzerland - Geneva',
  'Switzerland - Bern',
  'Turkey - Istanbul',
  'Turkey - Ankara',
  'Turkey - Izmir',
  'Ukraine - Kyiv',
  'Ukraine - Lviv',
  'United Kingdom - London',
  'United Kingdom - Manchester',
  'United Kingdom - Birmingham',
  'United Kingdom - Edinburgh',
  'United Kingdom - Glasgow',
  'United Kingdom - Liverpool',
  'Vatican City - Vatican City',

  // North America
  'Canada - Toronto',
  'Canada - Vancouver',
  'Canada - Montreal',
  'Canada - Calgary',
  'Canada - Ottawa',
  'Canada - Edmonton',
  'Costa Rica - San Jose',
  'Cuba - Havana',
  'Dominican Republic - Santo Domingo',
  'El Salvador - San Salvador',
  'Guatemala - Guatemala City',
  'Haiti - Port-au-Prince',
  'Honduras - Tegucigalpa',
  'Jamaica - Kingston',
  'Mexico - Mexico City',
  'Mexico - Guadalajara',
  'Mexico - Monterrey',
  'Mexico - Cancun',
  'Nicaragua - Managua',
  'Panama - Panama City',
  'Trinidad and Tobago - Port of Spain',
  'USA - New York',
  'USA - Los Angeles',
  'USA - Chicago',
  'USA - Houston',
  'USA - Phoenix',
  'USA - Philadelphia',
  'USA - San Antonio',
  'USA - San Diego',
  'USA - Dallas',
  'USA - San Francisco',
  'USA - Seattle',
  'USA - Denver',
  'USA - Washington DC',
  'USA - Boston',
  'USA - Atlanta',
  'USA - Miami',
  'USA - Portland',
  'USA - Las Vegas',
  'USA - Austin',
  'USA - Honolulu',

  // South America
  'Argentina - Buenos Aires',
  'Argentina - Cordoba',
  'Bolivia - La Paz',
  'Bolivia - Santa Cruz',
  'Brazil - Sao Paulo',
  'Brazil - Rio de Janeiro',
  'Brazil - Brasilia',
  'Brazil - Salvador',
  'Chile - Santiago',
  'Chile - Valparaiso',
  'Colombia - Bogota',
  'Colombia - Medellin',
  'Ecuador - Quito',
  'Ecuador - Guayaquil',
  'Guyana - Georgetown',
  'Paraguay - Asuncion',
  'Peru - Lima',
  'Peru - Cusco',
  'Suriname - Paramaribo',
  'Uruguay - Montevideo',
  'Venezuela - Caracas',

  // Africa
  'Algeria - Algiers',
  'Angola - Luanda',
  'Benin - Porto-Novo',
  'Botswana - Gaborone',
  'Burkina Faso - Ouagadougou',
  'Burundi - Bujumbura',
  'Cameroon - Yaounde',
  'Cape Verde - Praia',
  'Central African Republic - Bangui',
  'Chad - N\'Djamena',
  'Comoros - Moroni',
  'Congo - Brazzaville',
  'DR Congo - Kinshasa',
  'Djibouti - Djibouti',
  'Egypt - Cairo',
  'Egypt - Alexandria',
  'Equatorial Guinea - Malabo',
  'Eritrea - Asmara',
  'Eswatini - Mbabane',
  'Ethiopia - Addis Ababa',
  'Gabon - Libreville',
  'Gambia - Banjul',
  'Ghana - Accra',
  'Guinea - Conakry',
  'Guinea-Bissau - Bissau',
  'Ivory Coast - Abidjan',
  'Kenya - Nairobi',
  'Kenya - Mombasa',
  'Lesotho - Maseru',
  'Liberia - Monrovia',
  'Libya - Tripoli',
  'Madagascar - Antananarivo',
  'Malawi - Lilongwe',
  'Mali - Bamako',
  'Mauritania - Nouakchott',
  'Mauritius - Port Louis',
  'Morocco - Casablanca',
  'Morocco - Rabat',
  'Morocco - Marrakech',
  'Mozambique - Maputo',
  'Namibia - Windhoek',
  'Niger - Niamey',
  'Nigeria - Lagos',
  'Nigeria - Abuja',
  'Rwanda - Kigali',
  'Sao Tome and Principe - Sao Tome',
  'Senegal - Dakar',
  'Seychelles - Victoria',
  'Sierra Leone - Freetown',
  'Somalia - Mogadishu',
  'South Africa - Johannesburg',
  'South Africa - Cape Town',
  'South Africa - Durban',
  'South Africa - Pretoria',
  'South Sudan - Juba',
  'Sudan - Khartoum',
  'Tanzania - Dar es Salaam',
  'Tanzania - Dodoma',
  'Togo - Lome',
  'Tunisia - Tunis',
  'Uganda - Kampala',
  'Zambia - Lusaka',
  'Zimbabwe - Harare',

  // Oceania
  'Australia - Sydney',
  'Australia - Melbourne',
  'Australia - Brisbane',
  'Australia - Perth',
  'Australia - Adelaide',
  'Australia - Gold Coast',
  'Australia - Canberra',
  'Australia - Darwin',
  'Australia - Hobart',
  'Fiji - Suva',
  'New Zealand - Auckland',
  'New Zealand - Wellington',
  'New Zealand - Christchurch',
  'Papua New Guinea - Port Moresby',
  'Samoa - Apia',
  'Solomon Islands - Honiara',
  'Tonga - Nuku\'alofa',
  'Vanuatu - Port Vila',
];
